/* eslint-disable no-nested-ternary */
import React, { forwardRef } from 'react';

import { PanelFormsProvider } from 'contexts/panelFormsContext';
import { PropertiesPanelRef, PropertiesPanelProps, PropertiesPanelv3Content } from './Content';

export const PropertiesPanelv3 = forwardRef<PropertiesPanelRef, PropertiesPanelProps>((props, ref) => (
    <PanelFormsProvider>
        <PropertiesPanelv3Content {...props} ref={ref} />
    </PanelFormsProvider>
));
